import { Component } from '@theme/component';
import { CartAddEvent } from '@theme/events';
import { morphSection, sectionRenderer } from '@theme/section-renderer';

class W74CartAddons extends Component {
  #busy = false;
  #controller;

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }

  async add(event) {
    event.preventDefault();
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || this.#busy) return;
    const cartItems = this.closest('cart-items-component');
    const sectionId = cartItems?.dataset.sectionId;
    if (!sectionId || cartItems.classList.contains('cart-items-disabled')) return;
    const select = form.querySelector('select');
    const variant = select?.selectedOptions[0];
    if (!variant) return;
    const formId = form.id;
    const selectedId = select.value;
    const status = this.querySelector('.w74-addon-status');
    const errorMessage = this.dataset.error;
    const refreshMessage = this.dataset.refreshError;
    const addedMessage = this.dataset.added;
    const focusWasInside = form.contains(document.activeElement);
    this.#busy = true;
    this.#controller = new AbortController();
    const signal = this.#controller.signal;
    let added = false;
    cartItems.classList.add('cart-items-disabled');
    cartItems.setAttribute('aria-busy', 'true');
    const disabledControls = [...cartItems.querySelectorAll('button:not(:disabled), select:not(:disabled), input:not(:disabled)')].filter(el => !el.matches('[ref="closeButton"]'));
    disabledControls.forEach(el => { el.disabled = true; });
    status.textContent = '';
    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        signal,
        body: JSON.stringify({ items: [{ id: selectedId, quantity: Number(variant.dataset.min) || 1 }], sections: [sectionId], sections_url: window.location.pathname }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || errorMessage);
      added = true;
      let html = result.sections?.[sectionId];
      if (!html) html = await sectionRenderer.getSectionHTML(sectionId, false);
      if (signal.aborted) return;
      await morphSection(sectionId, html);
      const updatedCart = document.querySelector(`cart-items-component[data-section-id="${sectionId}"]`);
      const count = Number(updatedCart?.querySelector('[ref="cartItemCount"]')?.textContent) || 0;
      updatedCart?.dispatchEvent(new CartAddEvent(result, sectionId, { source: 'w74-cart-addons', itemCount: count, sections: { [sectionId]: html } }));
      const updatedForm = document.getElementById(formId);
      const updatedSelect = updatedForm?.querySelector('select');
      if (updatedSelect?.querySelector(`option[value="${selectedId}"]`)) updatedSelect.value = selectedId;
      const updatedStatus = updatedCart?.querySelector('.w74-addon-status');
      if (updatedStatus) updatedStatus.textContent = addedMessage;
      if (focusWasInside && updatedForm?.closest('dialog')?.open) updatedForm.querySelector('button')?.focus({ preventScroll: true });
    } catch (error) {
      if (error.name === 'AbortError') return;
      status.textContent = added ? refreshMessage : error.message || errorMessage;
      const recovery = this.querySelector('.w74-addon-recovery');
      if (recovery) recovery.hidden = false;
    } finally {
      this.#busy = false;
      disabledControls.forEach(el => { el.disabled = false; });
      cartItems.classList.remove('cart-items-disabled');
      cartItems.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('w74-cart-addons')) customElements.define('w74-cart-addons', W74CartAddons);
